import * as fromCustomer from './customer';
import * as fromAuth from './auth';
import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';

export interface AuthorizationState {
  customer: fromCustomer.CustomerState;
  auth: fromAuth.AuthState;
}

export const reducers: ActionReducerMap<AuthorizationState> = {
  customer: fromCustomer.reducer,
  auth: fromAuth.reducer,
};

export const effects = [fromCustomer.CustomerEffects, fromAuth.AuthEffects];

export const selectAuthorizationState = createFeatureSelector<AuthorizationState>('authorization');
